import React from 'react';

import { H1, H1PlusSmall } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn } from 'styles/layouts';

import { LandingButton } from '../../landingButton';
import LandingImage from '../../shared/LandingImage';
import { buttonAnalyticsMeta } from '../config';
import { Description } from '../Description';

import { Wrapper, ImageWrapper } from './styles';
import { VariationProps } from './types';

export const TwoColumnsVariation: React.FC<VariationProps> = ({
  title,
  description,
  button,
  image,
  isHeadline,
  buttonMeta,
}) => {
  return (
    <Wrapper>
      <FlexColumn alignItems="flex-start" gap="24px" justifyContent="center">
        <FlexColumn gap="20px">
          {isHeadline ? (
            <H1PlusSmall>{title}</H1PlusSmall>
          ) : (
            <H1 bold as="h2">
              {title}
            </H1>
          )}
          <Description alignCenter={false} description={description} />
        </FlexColumn>
        {!!button && (
          <LandingButton
            analyticsMeta={buttonMeta ?? buttonAnalyticsMeta}
            isSignUp={button.isSignUp}
            label={button.label}
            url={button.url}
          />
        )}
      </FlexColumn>
      <ImageWrapper>
        <LandingImage
          fill
          alt={image.alt ?? 'image'}
          provider={image.provider}
          src={image.url}
          style={{ objectFit: 'cover' }}
        />
      </ImageWrapper>
    </Wrapper>
  );
};
